
import { useState } from 'react'
import './styles/config.css'
import PanelExcepciones from '../components/config-components/PanelExcepciones'
import PanelCriticidades from '../components/config-components/PanelCriticidades'
import PanelGrupos from '../components/config-components/PanelGrupos'
import PanelBrands from '../components/config-components/PanelBrands'
import PanelTech from '../components/config-components/PanelTech'
import PanelProxies from '../components/config-components/PanelProxies'
import PanelModels from '../components/config-components/PanelModels'
import PanelHosts from '../components/config-components/PanelHosts'
import PanelAuditor from '../components/config-components/PanelAuditor'
import PanelGruposTelegram from '../components/config-components/MediosDifusion/PanelGruposTelegram'
import PanelPlantillaTelegram from '../components/config-components/MediosDifusion/PanelPlantillaTelegram'
import PanelComandosTelegram from '../components/config-components/MediosDifusion/PanelComandoTelegram'
import PanelMediciones from '../components/config-components/PanelMediciones'
import PanelTriggers from '../components/config-components/PanelTriggers'
import PanelEvents from '../components/config-components/PanelEvents'
import PanelEventsHistoric from '../components/config-components/PanelEventsHistoric'
import PanelCorrelation from '../components/config-components/PanelCorrelation'
import PanelIndicadores from '../components/config-components/PanelIndicadores'
import PanelCis from '../components/config-components/PanelCis'
// import UsersConfig from '../components/Config-components/UsersConfig'
// import Herramienta1 from '../components/Config-components/Herramienta1'
// import RolesConfig from '../components/Config-components/RolesConfig'
// import NotifiConfig from '../components/Config-components/NotifiConfig'
const Config=({server,dataGlobals,languaje,mode,pageSelected,handleShowPopup,userPermissions})=>{
    const [listSelected,setListSelected]=useState(1)
    const hadleChangeList=(e)=>{
        setListSelected(e)
    }
    return (
        <div className="main-config">
            {   pageSelected === 'config-agency' ? (
               <PanelExcepciones userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
               ) : 
               pageSelected === 'config-criticity' ? (
                    <PanelCriticidades userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
               ) :
               pageSelected === 'config-grupos' ? (
                  
                   <PanelGrupos  userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
               ) : pageSelected === 'config-proxies' ? (
                  
                   <PanelProxies userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
               ) :pageSelected === 'config-tec' ? (
                  
                   <PanelTech userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
               ) :pageSelected === 'config-brand' ? (
                  
                    <PanelBrands userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
               ) :pageSelected === 'config-models' ? (
                  
                   <PanelModels userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
              ):pageSelected === 'config-hosts' ? (
                  
               <PanelHosts userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
          ) :pageSelected === 'config-correlacion' ? (
                  
               <PanelCorrelation userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
          ) :pageSelected === 'config-audit' ? (
                  
           <PanelAuditor userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
      ) :pageSelected === 'config-telegram' ? (
                  
       <PanelGruposTelegram userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
  ) :pageSelected === 'config-platelegram' ? (
                  
   <PanelPlantillaTelegram userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
) :pageSelected === 'config-lastReadTele' ? (
                  
   <PanelComandosTelegram userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
) :pageSelected === 'config-Cis' ? (
                  
   <PanelCis userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
) :pageSelected === 'config-mediciones' ? (
                   (<PanelIndicadores userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>)
   // <PanelMediciones userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
) :pageSelected === 'config-disparadores' ? (
                  
   <PanelTriggers userPermissions={userPermissions}  handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
) :pageSelected === 'config-eventos' ? (
                  
   <PanelEvents userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
) :pageSelected === 'config-eventos-historic' ? (
                  
   <PanelEventsHistoric userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
) :<><>{''}</></>
               
               }
        </div>
    );
}

export default Config